import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../../contexts/notificationContext';
import ProjectModel from '../../models/ProjectModel';
import DataService from '../../services/data.service';
import ProjectCard from './../../components/Card/ProjectNewsItemCard';

const HomeView: React.FC = () => {
    const [projects, setProjects] = useState<ProjectModel[]>([])
    const navigate = useNavigate();
    const { handleException } = useNotifications();

    useEffect(() => {
        getProjects();
        //getEmails();
        const format = Intl.DateTimeFormat();
        console.log('format', format)
        const options = Intl.DateTimeFormat().resolvedOptions()
        console.log('options', options)
    }, [])

    function getProjects() {
        DataService
            .get<ProjectModel[]>(`api/v1/Projects/ForHome/`)
            .then(response => {
                setProjects(response);
            })
            .catch(e => handleException(e));
    }

    function getEmails()
    {
        DataService
            .get<string[]>(`api/v1/Emails/`)
    }

    let results = projects.map((item, index) => {
        return <ProjectCard project={item} handleProjectClicked={projectClicked} key={index} />
    });

    function projectClicked(project: ProjectModel) {
        let url = '/plm/Projects/Details/' + project.id;
        let navigateTitle = 'P ' + project.id;
        navigate(url, { state: { title: navigateTitle, fromMenu: false } });
    }

    return (
        <div className='main-content'>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'start', paddingLeft: 15 }}>
                {results}
            </div>
        </div>
    );
}
export default HomeView;